export default __webpack_public_path__ + "static/media/adImg1.bd28155f.jpg";